export type WhatsAppPlanTier = 'free' | 'starter' | 'pro' | 'enterprise';

/**
 * Phone caps enforced by TIER_PHONE_LIMITS in
 * apps/api/memara/services/twilio_whatsapp_service.py.
 * null is unlimited (server uses None).
 */
export const WHATSAPP_PHONE_LIMITS: Record<WhatsAppPlanTier, number | null> = {
  free: 1,
  starter: 3,
  pro: 10,
  enterprise: null,
};
